import React from 'react';
import { Typography, Stack, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PdfIcon } from 'assets/svg';
import { SaveAltIcon } from 'assets/icons';

interface FileDownloadProps {
  imageData: {
    id: string;
    name?: string;
    file: string;
  };
  handleDownload: (file: string) => void;
}

export const FileDownloadComponent: React.FC<FileDownloadProps> = ({
  imageData,
  handleDownload,
}) => {
  const theme = useTheme();

  return (
    <Stack
      my={1}
      direction="row"
      alignItems="center"
      spacing={1}
      border={`1px solid ${
        theme.palette.other?.border || theme.palette.divider
      }`}
      padding={0.75}
      borderRadius={1}
      width="fit-content"
      sx={{ background: theme.palette.grey[200] }}
    >
      <PdfIcon />
      <Typography variant="body2">{imageData?.name || 'Not Added'}</Typography>
      <IconButton size="small" onClick={() => handleDownload(imageData.file)}>
        <SaveAltIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
};
